// extracted by mini-css-extract-plugin
export default {"logoWrapper":"In_LP8w","logoIn":"VodP3lL"};